import React, { Component, Fragment } from 'react';
import Button from '../../artzu-ui/src/Button';

import { ValidatorForm } from 'react-form-validator-core';
import TextInput from '../User/TextInput';
import '../User/login.css';
import Modal from '../../artzu-ui/src/Modal';
import CheckBox from '../../artzu-ui/src/CheckBox';
import SaveRideshareParams from '../../GraphQL/Mutations/SaveRideshareParams';
import uberLogoRounded from '../../images/uberLogoRounded.png';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-solid-svg-icons';

class ReconnectUber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      submitParams: {},
      passwordShown: false
    };
  }

  // handleModal = open => {
  //   this.setState({ modalOpen: open });
  // };

  handlePassword = () => {
    this.setState({ passwordShown: !this.state.passwordShown });
  };

  handleChange = ({ target }) => {
    const { name } = target;
    const val = target.value;

    this.setState({ [name]: val });
  };

  handleSubmit = () => {
    const submit = this.state.submitParams;
    submit.name = this.props.platform;
    submit.password = this.state.password;
    submit.email = this.state.email;

    this.setState({ submitParams: submit }, () => {
      this.props.openModal(false);
    });
  };

  render() {
    const {
      status,
      connected_uber_email,
      rideshare,
      openModal,
      modalOpen,
      rideshareEmail,
      ridesharePassword,
      refetch
    } = this.props;
    const { password, email, passwordShown, submitParams } = this.state;
    return (
      <Fragment>
        <Modal open={modalOpen}>
          <ValidatorForm
            className="login__form"
            instantValidate={false}
            onSubmit={() => this.handleSubmit()}>
            <div className="login__modal-header">
              Reconnect your Uber account
            </div>
            <div className="login__modal-content">
              To continue, enter your email and password for your Uber
              account.
            </div>
            <div className="login__inputs">
              <TextInput
                floatingLabelText="Email"
                onChange={this.handleChange}
                name="email"
                placeholder={rideshareEmail}
                value={email.trim().replace(/\s/g, '')}
                validators={['required', 'isEmail']}
                errorMessages={[
                  'This field is required',
                  'Email is not valid'
                ]}
              />
              <TextInput
                style={{
                  marginLeft: '0',
                  paddingLeft: '3rem',
                  width: '31.5rem'
                }}
                floatingLabelText="Password"
                name="password"
                onChange={this.handleChange}
                placeholder={ridesharePassword}
                value={password}
                type={passwordShown ? 'text' : 'password'}
                validators={['required']}
                errorMessages={['This field is required']}
              />
              <CheckBox
                label={
                  passwordShown === true
                    ? 'Hide Password'
                    : 'Show Password'
                }
                onClick={() => {
                  this.handlePassword();
                }}
                disabled={password ? false : true}
                checkState={passwordShown}
              />
            </div>
            <SaveRideshareParams
              rideshareParams={submitParams}
              handleModal={openModal}
              handleSubmit={this.handleSubmit}
              refetch={refetch}
            />
          </ValidatorForm>
        </Modal>
        {status === 'pending_verification' ? (
          <div>
            <div className="connect__email">
              <div className="reconnect__header">
                Our team will contact you within 24 hours to verify your
                account.
              </div>
              <div className="connect__edit">
                <div>
                  <div className="connect__email--bold">Uber Email:</div>
                  <div className="connect__email--padding">
                    {rideshareEmail}
                  </div>
                </div>
                <div
                  className="icon-box"
                  onClick={() => {
                    openModal(true);
                  }}>
                  <FontAwesomeIcon icon={faPen} color="#128DFF" />
                  <div className="edit-label">Edit</div>
                </div>
              </div>
            </div>
            <div className="connect__password">
              <div className="connect__email--bold">Password</div>
              <div className="connect__password--padding">
                {ridesharePassword}
              </div>
            </div>
          </div>
        ) : status === '' || status === 'expired' ? (
          <div className="connect__body">
            <div className="reconnect__body">
              <div className="reconnect__header">
                Your Uber account has expired. Please enter your Uber email
                and password to activate and connect your account.
              </div>
              <div className="reconnect__button">
                <Button
                  label="Reconnect"
                  color="#128DFF"
                  fullWidth
                  onClick={() => {
                    openModal(true);
                  }}></Button>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="connect__email">
              <div className="connect__email--bold">Uber Email:</div>
              <div className="connect__email--padding">
                {rideshareEmail}
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default ReconnectUber;



// WEBPACK FOOTER //
// ./src/components/Connect/ReconnectUber.js